@if (authService.user$ | async; as user) {
  <dt-modal-content [contentPadding]="false" [showFooter]="false" size="small" (closeClick)="dialogRef.close()">
    <ng-template i18n #title>Profil</ng-template>
    <ng-template #content>
      @if (!user.emailConfirmed) {
        <div class="warning-row">
          <mat-icon>warning</mat-icon>&nbsp;
          <div i18n>E-Mail-Adresse nicht bestätigt. <a (click)="confirmEmail()">Jetzt bestätigen</a>.</div>
        </div>
      }
      <mat-divider></mat-divider>
      @if (screen === 'overview') {
        <mat-action-list>
          <mat-list-item (click)="screen = 'email'">
            <div matListItemTitle>E-Mail </div>
            <div matListItemLine>{{ user.email }}</div>
            <button mat-icon-button matListItemMeta>
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item (click)="screen = 'username'">
            <div matListItemTitle i18n>Benutzername</div>
            @if (user.name) {
              <div matListItemLine>{{ user.name }}</div>
            }
            @if (!user.name) {
              <div matListItemLine i18n>Kein Benutzername vergeben</div>
            }
            <button mat-icon-button matListItemMeta>
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item (click)="screen = 'password'">
            <div matListItemTitle i18n>Passwort</div>
            <div matListItemLine>**********</div>
            <button mat-icon-button matListItemMeta>
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </mat-list-item>
          <mat-list-item (click)="deleteAccount()">
            <div matListItemTitle i18n>Account löschen</div>
            <button mat-icon-button matListItemMeta>
              <mat-icon>delete</mat-icon>
            </button>
          </mat-list-item>
        </mat-action-list>
      }
      @if (screen !== 'overview') {
        <div class="screen-header">
          <mat-icon (click)="screen = 'overview'">keyboard_arrow_left</mat-icon>
          @switch (screen) {
            @case ('email') {
              <span class="mat-h3" i18n>E-Mail-Adresse ändern</span>
            }
            @case ('username') {
              <span class="mat-h3" i18n>Benutzernamen ändern</span>
            }
            @case ('password') {
              <span class="mat-h3" i18n>Passwort ändern</span>
            }
          }
        </div>
      }
      @if (screen !== 'overview') {
        <div class="screen-container">
          @if (screen === 'email') {
            <dt-change-email></dt-change-email>
          }
          @if (screen === 'username') {
            <dt-change-username></dt-change-username>
          }
          @if (screen === 'password') {
            <dt-change-password (changePasswordSuccess)="screen = 'overview'"></dt-change-password>
          }
        </div>
      }
    </ng-template>
  </dt-modal-content>
}
